import React, { useEffect } from 'react'
// import VisitorCount from '../Components/VisitorCount';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { TypeAnimation } from 'react-type-animation';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomePageStyled = styled.header`
    width: 100%;
    height: 100vh;
    position: relative;
    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 92%;
        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid #790079;
                    color: #790079;
                }
            }
            .i-linkedIn{
                &:hover{
                    border: 2px solid #0077b5;
                    color: #0077b5;
                }
            }
            .i-twitter{
                &:hover{
                    border: 2px solid #1DA1F2;
                    color: #1DA1F2;
                }
            }
            .i-instagram{
                &:hover{
                    border: 2px solid #bc2a8d;
                    color: #bc2a8d;
                }
            }
        }
        .anim{
            text-align:center !important;
            width: 0ch;
            overflow: hidden;
            white-space: nowrap;
            animation: text 8s steps(26) infinite alternate;
            border-right: 3px solid #13265d;
        }
        @keyframes text{
            0%{
                width: 0ch;
            }
            50%{
                width: 18ch;
            }
        }
    }
`;

const HomePage = () => {

    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    return (
        <HomePageStyled>
            {/* <VisitorCount /> */}
            <div className="typography">
                <h1 data-aos="fade-down">Hi, I'm <span>Mohd Tausif</span></h1>
                <TypeAnimation
                    sequence={[
                        `I'm a Full-Stack Web Developer`,
                        1000,
                        `I have 3+ Years of Experience`,
                        1000
                    ]}
                    wrapper="p"
                    speed={50}
                    style={{ fontSize: '22px' }}
                    repeat={Infinity}
                />
                <div className="icons">
                    <a href="https://www.linkedin.com/in/mohdtausif/" target="_blank" rel="noopener noreferrer" className="icon i-linkedIn" data-aos="fade-right">
                        <LinkedInIcon />
                    </a>
                    <a href="https://github.com/sheikhtausif" target="_blank" rel="noopener noreferrer" className="icon i-github" data-aos="fade-up">
                        <GitHubIcon />
                    </a>
                    <a href="https://twitter.com/executive_error" target="_blank" rel="noopener noreferrer" className="icon i-twitter" data-aos="fade-up">
                        <XIcon />
                    </a>
                    <a href="https://instagram.com/executive_error/" target="_blank" rel="noopener noreferrer" className="icon i-instagram" data-aos="fade-left">
                        <InstagramIcon />
                    </a>
                </div>
            </div>
        </HomePageStyled>
    )
}
export default HomePage